import { SPONSORED_CONTENT_LOADED } from '../../../../actions/sponsoredContent';

import type { Action } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { SponsoredContentState } from '@web-platform/shared-universal-types/src/redux/state/entities/sponsoredContent';
import type { EmptyObject } from '@web-platform/shared-universal-types-utils/src/utils';

export const sponsoredContentReducer = (
  state: SponsoredContentState | EmptyObject = {},
  action: Action,
): SponsoredContentState | EmptyObject => {
  switch (action.type) {
    case SPONSORED_CONTENT_LOADED:
      return action.payload.sponsoredContent;
    default:
      return state;
  }
};
